import { render, staticRenderFns } from "./BonusTable.vue?vue&type=template&id=ad201462&"
import script from "./BonusTable.vue?vue&type=script&lang=js&"
export * from "./BonusTable.vue?vue&type=script&lang=js&"
import style0 from "./BonusTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports